import { logFeatureUsage as serverLog } from './NsLogger';

/**
 * Dispatches a log
 *
 * @param {string} featureType The feature being used by the user interaction.
 * @param {string} sourceId The unique ID associated with the original item the user is interacting with.
 * @param {string} destinationId The ID of the item being viewed (ex: link, hover, title).
 */
export function logFeatureUsage(featureType, sourceId, destinationId) {
		serverLog(featureType, sourceId, destinationId);
}



// WEBPACK FOOTER //
// ./src/lib/analytics/AnalyticsController.js